import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";

import { numberWithCommas } from "modules/functions";
import globalConstants from "constants/globalConstants";
import * as css from "styles/CssVariables.js";
import streakIcon from "assets/img/icons/flash-icon-indigo.svg";

const StreakBox = styled.div`
  height: 60px;
  padding: 0px 25px;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: 30px;

  transition: 0.2s;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  @media (max-width: ${globalConstants.switchMobile}) {
    height: 48px;
    padding: 0px 20px;

    border-radius: 24px;

    gap: 8px;
  }

  &:hover {
    cursor: help;
  }
`;

const StreakIcon = styled.div``;

const Icon = styled.div`
  width: 24px;
  min-width: 24px;
  height: 24px;

  @media (max-width: ${globalConstants.switchMobile}) {
    width: 20px;
    min-width: 20px;
    height: 20px;
  }
`;

const Streak = styled.div`
  font-size: 18px;
  font-weight: 500;

  @media (max-width: ${globalConstants.switchMobile}) {
    font-size: 16px;
  }
`;

export default ({ streak }) => {
  const navigate = useNavigate();

  return (
    <>
      <StreakBox
        data-tooltip-id="streakBonus"
        data-tooltip-html="For each day you find coins, your Activity Streak Bonus increases by one percentage point.<br><br>If you miss a day, your bonus resets back to 0%, and you'll start over.<br><br><a href='https://help.scalelup.com/en/articles/11320560-activity-streak-bonus' target='_blank' class='tooltip-link'>Learn more</a>"
        data-tooltip-place="top"
        data-tooltip-delay-show={500}
        data-tooltip-delay-hide={500}
      >
        <StreakIcon>
          <Icon>
            <img src={streakIcon} style={{ width: "100%" }} />
          </Icon>
        </StreakIcon>
        <Streak>{numberWithCommas(streak)}</Streak>
      </StreakBox>
      <Tooltip id="streakBonus" className="tooltip" clickable />
    </>
  );
};
